import { downloadBlob } from '@lib/download';
import { TypographyDownloadLinkStyled } from './download-file-link.styled';
import axiosClient from '@services/axiosClient';

interface IProps {
  label: string;
  link: string;
  fileName: string;
}

export const DownloadFileLink: React.FC<IProps> = ({
  label,
  link,
  fileName,
}) => {
  const onClickDownload = () => {
    axiosClient
      .get(link)
      .then(({ data }) => {
        const blob = new Blob([data], { type: 'application/csv' });
        downloadBlob(blob, `${fileName}.csv`);
      })
      .catch(console.error);
  };
  return (
    <TypographyDownloadLinkStyled onClick={onClickDownload}>
      {label}
    </TypographyDownloadLinkStyled>
  );
};
